/**
 *
 * @param {String} CSS classes to join
 * @returns {String} final cssClass properly joined
 */
function classNames(...classes) {
  return classes.filter((item) => !!item).join(" ");
}

/**
 *
 *
 * @param {Array} collection to clean
 * @returns {Array} a new collection without false values
 */
function discardFalses(collection) {
  return collection.filter((i) => i);
}

export { classNames, discardFalses };
